var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip-group',{attrs:{"column":"","active-class":"primary--text"}},_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag,staticClass:"ma-1",attrs:{"label":"","x-small":"","color":"primary","text-color":"white"}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }